import { RequirementType } from "@wingspanhq/wingspan-api-sdk";
import { WSQueryResult } from "@ws-react-query";

import { queriesBackgroundCheckConfigurations } from "../../../v3/query/queriesBackgroundCheckConfigurations";
import { queriesDocumentTemplates } from "../../../v3/query/queriesDocumentTemplates";
import { queriesInsuranceMonitorConfigurations } from "../../../v3/query/queriesInsuranceMonitorConfigurations";
import { queriesSharedFileRequestConfigurations } from "../../../v3/query/queriesSharedFileRequestConfigurations";
import { RequirementDefinitionSettingsItem } from "../types";

// Signature reads the v3 document template, DocumentUpload the v3
// shared-file-request configuration, BackgroundCheck the v3 background-check
// configuration and InsuranceCoverage the v3 monitor configuration
// (TODO(v3-verify): all four assume v1-authored ids resolve on the v3
// endpoints — same backing store per the API design docs).
export const useRequirementDefinitionSettings = (props?: {
  // the v3 template models an absent data source as an explicit `null`
  dataSourceId?: string | null;
  requirementType?: RequirementType;
}): WSQueryResult<RequirementDefinitionSettingsItem, any> => {
  const dataSourceId = props?.dataSourceId as string;
  const requirementType = props?.requirementType as RequirementType;
  const enabled = !!dataSourceId;

  const documentTemplateQuery =
    queriesDocumentTemplates.getDocumentTemplate.useQuery(
      { templateId: dataSourceId },
      {
        enabled: props?.requirementType === RequirementType.SIGNATURE && enabled
      }
    );
  const sharedFileSettingsQuery =
    queriesSharedFileRequestConfigurations.getSharedFileRequestConfiguration.useQuery(
      { sharedFileRequestConfigurationId: dataSourceId },
      {
        enabled: requirementType === RequirementType.DOCUMENT_UPLOAD && enabled
      }
    );

  const backgroundChecksSettingsQuery =
    queriesBackgroundCheckConfigurations.getBackgroundCheckConfiguration.useQuery(
      { backgroundCheckConfigurationId: dataSourceId },
      {
        enabled: requirementType === RequirementType.BACKGROUND_CHECK && enabled
      }
    );

  const monitorSettingsQuery =
    queriesInsuranceMonitorConfigurations.getInsuranceMonitorConfiguration.useQuery(
      { insuranceMonitorConfigurationId: dataSourceId },
      {
        enabled:
          requirementType === RequirementType.INSURANCE_COVERAGE && enabled
      }
    );

  switch (requirementType) {
    case RequirementType.BACKGROUND_CHECK:
      return backgroundChecksSettingsQuery;
    case RequirementType.SIGNATURE:
      return documentTemplateQuery;
    case RequirementType.DOCUMENT_UPLOAD:
      return sharedFileSettingsQuery;
    case RequirementType.INSURANCE_COVERAGE:
      return monitorSettingsQuery;
    default:
      return {
        data: undefined,
        isDisabled: true,
        isError: false,
        isInitialLoading: false,
        isLoading: false
      } as any;
  }
};
